export default "__VITE_ASSET__BGcy5cjE__"